import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Setting } from 'src/app/models/setting';
import * as fromRoot from 'src/app/state/app.state';
import { SettingsActions, SettingsActionTypes } from './settings.actions';

export interface SettingsState {
  settings: Setting[];
  loaded: boolean;
  error: string;

}

export interface State extends fromRoot.State {
  settings: SettingsState;
}

const initialSettingsState: SettingsState = {
  settings: [],
  loaded: false,
  error: ''
};

const getSettingsFeatureState = createFeatureSelector<SettingsState>('settings');
export const getSettingsLoaded = createSelector(getSettingsFeatureState, state => state.loaded);
export const getSettings = createSelector(getSettingsFeatureState, state => state.settings);
export const getError = createSelector(getSettingsFeatureState, state => state.error);
// export const getAreas = createSelector(getSettingsFeatureState, state => state['Bereiche'] || []);

export function reducer(state: SettingsState = initialSettingsState, action: SettingsActions): SettingsState {
  switch (action.type) {

    case SettingsActionTypes.LoadSuccess:
      return {
        ...state,
        settings: action.payload,
        error: ''
      };

    case SettingsActionTypes.LoadFail:
      return {
        ...state,
        settings: [],
        error: action.payload
      };

    default:
      return state;
  }
}
